import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, AfterViewChecked } from '@angular/core';
import { DxAutocompleteComponent, DxNumberBoxComponent } from 'devextreme-angular';
import { EventService } from 'src/app/services/event.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { AppointmentState } from '../../model/appointment-book.models';
import { Course, Product, Resource, Session } from '../../model/resource.model';
import { SaleItemEditorComponent } from '../sale-item-editor/sale-item-editor.component';
import { enumSaleItemType, SaleItem } from '../../model/SaleItem';
import { TransactionService } from 'src/app/services/transaction.service';
import notify from 'devextreme/ui/notify';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { debounceTime, take } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { CreditsCalculatorComponent } from '../credits-calculator/credits-calculator.component';
import { VoucherCodeComponent } from '../voucher-code/voucher-code.component';
import { VoucherTenderComponent } from '../voucher-tender/voucher-tender.component';
import { enumAS365FeatureFlags } from 'src/app/services/default-data.service';
import { VoucherDetails } from '../../model/voucher-details.model';
import { BookAptInfo } from '../../model/BookAptInfo';
import { AppointmentBookService } from 'src/app/services/appointment-book.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { Appointment } from 'devextreme/ui/scheduler';
import { AddProductComponent } from '../add-product/add-product.component';
import { DxDropDownButtonTypes } from 'devextreme-angular/ui/drop-down-button';
import { CardPaymentService } from 'src/app/services/worldpay/card-payment.service';
import { ConstantsService } from 'src/app/services/constants.service';

export type ItemObject = DxDropDownButtonTypes.Item & { value: number | string, name: string };

@Component({
  selector: 'app-appointment-makesale',
  templateUrl: './appointment-makesale.component.html',
  styleUrls: ['./appointment-makesale.component.css']
})
export class AppointmentMakeSaleComponent implements OnInit, OnDestroy, AfterViewChecked {
  @Input() aptState: AppointmentState = AppointmentState.New;
  @Input() selectedClientId = -1;
  @Input() allowSaleOfCourses = false;
  @Input() showCancelButton = false;
  @Input() showNoSaleButton = false;
  @Input() bookAptInfo: BookAptInfo;
  @Input() allowOverlap = true;
  @Input() showPaymentAfterSessionBookApt = false;

  @Output() onSaleMade: EventEmitter<SaleItem[]> = new EventEmitter<SaleItem[]>();
  @Output() onBookAppointment: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() onCancelSale: EventEmitter<null> = new EventEmitter<null>();
  @Output() onNoSale: EventEmitter<null> = new EventEmitter<null>();

  FFVouchers: boolean = this.session.IsFeatureEnabled(enumAS365FeatureFlags.Vouchers) || false;

  tenderAmountValue = 0.0;
  outstandingBalance = 0.0;
  saleItems: Array<SaleItem> = new Array<SaleItem>(50);
  ProductList: Array<Product> = new Array<Product>(500);
  CoursesList: Array<Course> = new Array<Course>(500);
  subtotal = 0;
  total = 0;
  AllowBooking = false;
  disableMakeSale = true;
  disableBookApt = true;
  showSaleItemPopup = false;
  btnTenderCardDisabled = false;
  saleChecked = false;
  isAdmin = false;
  hasCanEditPricesPrivs = false;
  searchExpression='["ProductName"]';

  invoiceItems: SaleItem[] = [];
  upperItems: SaleItem[] = [];
  lowerItems: SaleItem[] = [];

  selectedSession: Session = null;
  selectedResource: Resource = null;

  onDefaultDataChanged$: Subscription;
  onAddSession$: Subscription;
  onAddResource$: Subscription;

  checkSale$: Subject<any> = new Subject();
  tender$: Subject<any> = new Subject();

  btnUseCredits: any;
  addCourseCtlInitialised = false;
  hasPayPoint = false;
  usedPayPoint = false;

  creditCardOptions: ItemObject[]=[{value: 1, name: 'Manual'}];

  @ViewChild(AddProductComponent) addProductComponent: AddProductComponent;
  @ViewChild('ctlAddCourse') addCourseCtl: DxAutocompleteComponent;
  @ViewChild(SaleItemEditorComponent) dlgEditSaleItem: SaleItemEditorComponent;
  @ViewChild('tenderAmount') tenderAmountCtl: DxNumberBoxComponent;
  @ViewChild(DisclaimerComponent) dlgAcceptDisclaimer: DisclaimerComponent;
  @ViewChild(CreditsCalculatorComponent) dlgCreditsCalculator: CreditsCalculatorComponent;
  @ViewChild(VoucherCodeComponent) dlgVoucherCode: VoucherCodeComponent;
  @ViewChild(VoucherTenderComponent) dlgTenderVoucher: VoucherTenderComponent;

  filterByBranchPredicate = (i) => ((!i.Branch) || i.Branch === this.session.ctx.BranchId) && i.Active === true;
  UseCredits: boolean = true;


  sortProducts(a: Product, b: Product) {
    return a.ProductName.localeCompare(b.ProductName, undefined, { sensitivity: 'base' });
  }

  sortCourses(a: Course, b: Course) {
    if (a.Price == b.Price) {
      return a.CourseName.localeCompare(b.CourseName, undefined, { sensitivity: 'base' });
    }
    else
      return (a.Price < b.Price ? -1 : 1);
  }

  constructor(
    private event: EventService,
    private session: SessionContextService,
    private transactionManager: TransactionService,
    private appointmentBookService: AppointmentBookService,
    private changeDetectorRef: ChangeDetectorRef, 
    private cardPaymentService: CardPaymentService,
    private constants: ConstantsService,
  ) {
    var x = this.session.ctx.Employee.PrivString.split(',').filter(i => i.toLowerCase() == "admin");
    if (x.length > 0)
      this.isAdmin = true;

    this.hasCanEditPricesPrivs = this.session.ctx.Employee.CanEditPrices;
    this.hasPayPoint = this.session.DoesTerminalHaveTPayPoint;
    
    this.onDefaultDataChanged$ = this.event.onDefaultDataChanged.subscribe(r => {
      if (r) {
        this.FFVouchers = this.session.IsFeatureEnabled(enumAS365FeatureFlags.Vouchers) ||false;
        this.ProductList = r.Products.filter(i => this.filterByBranchPredicate(i)).sort((a, b) => this.sortProducts(a, b));
        this.CoursesList = r.Courses.filter(i => this.filterByBranchPredicate(i)).sort((a, b) => this.sortCourses(a, b));;
      }
    });
    this.FFVouchers = this.session.IsFeatureEnabled(enumAS365FeatureFlags.Vouchers) ||false;
    this.ProductList = this.session?.defaultData?.defData?.Products?.filter(i => this.filterByBranchPredicate(i)).sort((a, b) => this.sortProducts(a, b));
    this.CoursesList = this.session?.defaultData?.defData?.Courses?.filter(i => this.filterByBranchPredicate(i)).sort((a, b) => this.sortCourses(a, b));

    this.checkSale$.pipe(debounceTime(200)).subscribe((_) => {
      this.saleItems.forEach((i: SaleItem) => {
        i.ShowEditor = 0;
        i.EditorData = null;
      });
      this.transactionManager
        .CheckSale(
          this.selectedClientId,
          this.session.ctx.BranchId,
          this.session.ctx.TerminalId,
          this.UseCredits,
          this.saleItems,
          this.bookAptInfo?.apt?.AppointmentId || -1
        )
        .pipe(take(1))
        .subscribe({
          next: (r: SaleItem[]) => {
            if (r) {
              this.saleItems = r;
            }
            this.UpdateSaleItems();
            this.saleChecked = true;
            this.UpdateUI();
            
            // if remaining balance is zero and we can process the sale, 
            // and pay point was used to complete the sale then auto make sale
            if (this.usedPayPoint && (!this.disableMakeSale)){
              this.usedPayPoint = false;
              this.btnMakeSale(undefined);
            }
            this.usedPayPoint = false;
          },
          error: (e) => {
            // Handle error
            notify(e, 'error', 10000);
          },
        });
    });

    this.tender$
      .pipe(debounceTime(200))
      .subscribe((item) => {
        this.doTender(item);
      });

    this.Reset();

    this.onAddSession$ = this.transactionManager.onAddSession.subscribe((s) => {
      this.selectedSession = s;
      if (s) {
        let si = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.Session);
        if (si == null) {
          si = new SaleItem();
          this.saleItems.unshift(si);

          const q = this.saleItems.filter(i => i.SaleItemType < enumSaleItemType.CashTendered).length || 0;
          si.SaleItemId = q + 1;
          si.Qty = 1;
          si.Tendered = false;
          si.SaleItemType = enumSaleItemType.Session;
          this.UpdateSale();
        }
        if ((si.ProductId !== s.SessionId) || (si.Description !== s.SessionName) || (si.Price || s.RetailPrice) || (si.Qty !== 1)) {
          si.ProductId = s.SessionId;
          si.Description = s.SessionName;
          si.Price = s.RetailPrice;
          si.Qty = 1;
          si.StaffUpdatedPrice = false;
          if (si.ResourceId && (si.ResourceId > 0)) {
            this.UpdateSale();
          }
        }
      }
    });

    this.onAddResource$ = this.transactionManager.onAddResource.subscribe((r) => {
      this.selectedResource = r;
      if (r && (this.saleItems.length > 0)) {
        // Update Sale Item for session
        const si = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.Session);
        if (si && (si.ResourceId !== r.ResourceId)) {
          si.ResourceId = r.ResourceId;
          this.UpdateSale();
        }
      }
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    if (!this.addCourseCtlInitialised && this.addCourseCtl) {
      this.addCourseCtlInitialised = true;
      setTimeout(() => {
        if (this.selectedClientId <= -1) {
          this.focusAddProduct();
        }
      }, 200);
    }
  }

  ngOnDestroy() {
    if (this.onDefaultDataChanged$) { this.onDefaultDataChanged$.unsubscribe(); }
    if (this.onAddSession$) { this.onAddSession$.unsubscribe(); }
    if (this.onAddResource$) { this.onAddResource$.unsubscribe(); }
    if (this.checkSale$) { this.checkSale$.unsubscribe(); }
    if (this.tender$) { this.tender$.unsubscribe(); }
  }

  deleteItem(e: any, item: SaleItem) {
    // We should not be able to delete session sale item
    if (item && item.SaleItemType === enumSaleItemType.Session) {
      return;
    }

    // Remove selected item
    this.saleItems = this.saleItems.filter(i => i.SaleItemId !== item.SaleItemId);

    // reset any insufficient credits calculations
    if (item && item.SaleItemType === enumSaleItemType.Course){
      this.ResetCreditsCalculations();
    }

    // Remove any Tender items if deleted item is product or course
    this.RemoveTenderItems();
  }

  editSaleItem(e: any, item: SaleItem) {
    this.dlgEditSaleItem.show(item);
  }

  focusAddProduct() {
    this.addProductComponent.addProductCtl.instance.instance().focus();
  }

  onProductInputValueChanged(code: string) {
    setTimeout(() => {
      if (code && (code.length>5)) {
        const products = this.ProductList.filter(i => i.BarCode && (i.BarCode === code));
        switch (products?.length || 0){
          case 0:
            // no matching products, check against name
            const matches = this.ProductList.filter(i => i.ProductName.toLowerCase().startsWith(code.toLowerCase()));
            if (!matches.length) {
              if (this.ProductList.findIndex((i) => i.ProductName.toLowerCase().includes(code.toLowerCase())) === -1) {
                notify('Product not found. Please try again or select the product from the list of available products', 'error', 3000);
                this.ClearSelectedProduct();
              }
            }
            break;
          case 1:
            // only one matching product.  Add to basket
            this.addProduct(products[0]);
            break;
          default:
            // found more than one matching product, do nothing
            break;
        }
      }
    }, 200);
  }

  onProductSelected(product: Product) {
    this.addProduct(product);
  }

  addProduct(product: any){
    if (product){
      let si: SaleItem = null;
      si = this.saleItems.find(i => i.ProductId === product.ProductId && product.IsVoucher == false);
      if (si === undefined) {
        si = new SaleItem();

        const q = this.saleItems.filter(i => i.SaleItemType < enumSaleItemType.CashTendered).length;
        si.SaleItemId = q + 1;

        si.ProductId = product.ProductId;
        si.Description = product.ProductName;
        si.Price = product.Price;
        si.Tendered = false;
        si.Qty = 1;
        this.saleItems.unshift(si);

        if (product.IsVoucher == false) {
          si.SaleItemType = enumSaleItemType.Product;
          si.IsVoucher = false;
        }
        else {
          si.SaleItemType = enumSaleItemType.Voucher;
          si.IsVoucher = true;
          si.VoucherCode = "";
          si.ShowEditor = 3;
          si.CashValue = product.CashValue;
        }
      }
      else {
        si.Qty = si.Qty + 1;
      }

      this.RemoveTenderItems();
      this.ClearSelectedProduct();
      this.addProductComponent.addProductCtl.instance.close();
      this.addProductComponent.addProductCtl.instance.reset();
      this.addProductComponent.productInputFilter = '';
      this.addProductComponent._productList = this.ProductList;
    }
    this.UpdateSaleItems();
  }

  ClearSelectedProduct(){
    this.addCourseCtl.instance.resetOption('text');
    this.addCourseCtl.instance.reset();
    this.changeDetectorRef.detectChanges();
  }

  VoucherCodeDlgClosed(e) {    
    if (e.Action == "CANCEL") {
      this.deleteItem(null, e.saleItem);
    }
    else if (e.Action == "UPDATE") {      
      this.saleItems.unshift(e.saleItem);
      this.RemoveTenderItems();
      this.UpdateSale();
    }
  }

  onCourseChanged(e) {
    if (e.itemData) {
      let si: SaleItem = null;
      si = this.saleItems.find(i => i.ProductId === e.itemData.CourseId);
      if (si === undefined) {
        si = new SaleItem();

        const q = this.saleItems.filter(i => i.SaleItemType < enumSaleItemType.CashTendered).length;
        si.SaleItemId = q + 1;

        si.ProductId = e.itemData.CourseId;
        si.Description = e.itemData.CourseName;
        si.Price = e.itemData.Price;
        si.Qty = 1;
        si.Tendered = false;
        si.SaleItemType = enumSaleItemType.Course;
        this.saleItems.unshift(si);
      } else {
        si.Qty = si.Qty + 1;
      }
      this.ResetCreditsCalculations();
      this.RemoveTenderItems();

      if (this.addCourseCtl) {
        this.addCourseCtl.instance.beginUpdate();
        this.addCourseCtl.instance.option('selectedItem', null);
        this.addCourseCtl.instance.option('value', null);
        this.addCourseCtl.instance.option('opened', false);
        this.addCourseCtl.instance.resetOption('text');
        this.addCourseCtl.instance.reset();
        this.addCourseCtl.instance.endUpdate();
      }
      this.changeDetectorRef.detectChanges();
    }
  }

  UpdateSaleItems() {
    this.upperItems = this.saleItems.filter(i =>
      i.SaleItemType >= enumSaleItemType.SaleValue &&
      i.SaleItemType <= enumSaleItemType.TotalToPay
    ).sort((a, b) => a.SaleItemType - b.SaleItemType);
    this.lowerItems = this.saleItems.filter(i => i.SaleItemType >= enumSaleItemType.TotalTendered)
      .sort((a, b) => a.SaleItemType - b.SaleItemType);
    this.invoiceItems = this.saleItems.filter(i => i.SaleItemType < enumSaleItemType.SaleValue).sort((a, b) => a.SaleItemId - b.SaleItemId);

    var edt = this.saleItems.find(i => i.ShowEditor == 2);
    if (edt != null) {
      // Show Editor   
      this.dlgCreditsCalculator.show(edt.EditorData, edt);
    }

    var edt = this.saleItems.find(i => i.ShowEditor == 3);
    if (edt != null) {
      // Show Editor  
      this.dlgVoucherCode.show(edt, this.saleItems);
    }
  }

  CreditsCalculatorDlgClosed(e) {
    if (e != null) {
      // Update Sale
      e.ShowEditor = 0;
      e.EditorData = null;
      e.CreditsCalculated = true;
      this.UpdateSale();
    }
  }

  UpdateSale() {
    this.checkSale$.next(undefined);
  }

  UpdateUI() {
    const siSaleTotal = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.SaleValue);
    const siOB = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.OutstandingBalance);
    this.outstandingBalance = siOB.Price;

    this.tenderAmountValue = siOB.Price;
    if (this.tenderAmountCtl) {
      this.tenderAmountCtl.value = siOB.Price;
      console.log('Set tender amount to ', siOB.Price);
    }
    const saleItemCount = this.saleItems.filter(i => i.SaleItemId < 1000).length;
    this.disableMakeSale = ((saleItemCount > 0 && siOB.Price > 0.0) || (saleItemCount == 0));
    this.disableBookApt = !(this.selectedSession != null && this.selectedResource != null);

    const si = this.saleItems.find(i =>
      i.Tendered === true
      && (i.SaleItemType === enumSaleItemType.CashTendered)
      || (i.SaleItemType === enumSaleItemType.CardTendered));
    this.AllowBooking = (si) ? false : true;

    // If Apt is not new then do not show Allow Booking.
    if (this.aptState > AppointmentState.New) {
      this.AllowBooking = false;
    }
    if (this.AllowBooking === false) {
      this.disableBookApt = true;
    }

    this.onTenderValueChanged({ value: siOB.Price });
    this.changeDetectorRef.detectChanges();
    this.focusAddProduct();
  }

  btnMakeSale(e) {
    if (
      this.bookAptInfo &&
      this.bookAptInfo.State < AppointmentState.Attended &&
      this.allowOverlap
    ) {
      this.bookAptInfo.startTime = this.bookAptInfo.requestedStartTime;
      this.appointmentBookService
        .getConflictingAppointment(this.bookAptInfo)
        .pipe(take(1))
        .subscribe((result: Appointment) => {
          if (result) {
            confirm(
              'This appointment will overlap with another appointment. Are you sure you want to continue?',
              'Confirm Booking'
            ).then((result) => {
              if (result) {
                this.MakeSale(e);
              }
            });
          } else {
            this.MakeSale(e);
          }
        });
    } else {
      this.MakeSale(e);
    }
  }

  MakeSale(e) {
    this.disableMakeSale = true;
    this.disableBookApt = true;
    this.changeDetectorRef.detectChanges();

    // Show Disclaimer dlg if needed.
    if (
      this.selectedResource != null &&
      (this.selectedResource?.SafetyPolicyDisclaimerRequired || this.selectedResource?.SkinTypeDisclaimerRequired)
    ) {
      if (
        this.session.defaultData.defData.customerSettings.DisableSafetyPolicyOverride &&
        this.selectedResource?.SafetyPolicyDisclaimerRequired
      ) {
        alert(
          "The client has exceeded the maximum number of sessions permitted within the safety policy.",
          "Safety Policy"
        ).then(() => {});
      } else if (
        this.session.defaultData.defData.customerSettings.DisableSkinTypeOverride &&
        this.selectedResource?.SkinTypeDisclaimerRequired
      ) {
        alert(
          "The session/resource you have selected exceeds this client's maximum session length. Please select a shorter session to continue.",
          "Safety Policy"
        ).then(() => {});
      } else {
        const si: SaleItem = this.saleItems.find((i) => i.SaleItemType === enumSaleItemType.Session);
        if (si != null) {
          this.selectedResource.DisclaimerCode = si.DisclaimerCode;
        }
        this.dlgAcceptDisclaimer.show(this.selectedResource);
      }
    } else {
      this.CompleteSale();
    }
  }

  DisclaimerDlgClosed(e) {
    if (e.Signed) {
      {
        const si: SaleItem = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.Session);
        if (si != null) {
          si.DisclaimerAccepted = true;
          si.DisclaimerAcceptanceType = e.AcceptanceType;
        }
        this.CompleteSale();
      }
    } else {
      this.UpdateSale();
    }
  }

  CompleteSale() {
    // If cash tendered then pop till drawer
    var openTillDrawer = this.saleItems.find(i => i.SaleItemType == enumSaleItemType.CashTendered);
    if (openTillDrawer) {
      this.event.OpenTillDrawer(this.session.GetSelectedTerminal().TillDrawerId);
    }

    this.onSaleMade.emit(
      this.saleItems
    );
    this.Reset();
  }

  btnBookApt(e) {
    if (
      this.session.defaultData.defData.customerSettings.DisableSafetyPolicyOverride &&
      this.selectedResource?.SafetyPolicyDisclaimerRequired
    ) {
      alert(
        "The client has exceeded the maximum number of sessions permitted within the safety policy.",
        "Safety Policy"
      ).then(() => {});
    } else if (
      this.session.defaultData.defData.customerSettings.DisableSkinTypeOverride &&
      this.selectedResource?.SkinTypeDisclaimerRequired
    ) {
      alert(
        "The session/resource you have selected exceeds this client's maximum session length. Please select a shorter session to continue.",
        "Safety Policy"
      ).then(() => {});
    } else {
      this.onBookAppointment.emit(new Date());
    }
  }

  btnCancel(e) {
    this.onCancelSale.emit();
    this.Reset();
  }

  btnNoSale(e) {
    this.onNoSale.emit();
    this.Reset();
  }

  onTenderValueChanged(e) {
    if (e == null || e.component == null) {
      return;
    }

    this.tenderAmountValue = e.component._parsedValue;
    if (this.tenderAmountValue === undefined) {
      this.tenderAmountValue = 0.0;
    }

    console.log('Tender value changed ', this.tenderAmountValue);
  }

  btnTender(e, item) {
    this.tender$.next(item);
  }

  onItemClick(e){
    // process card payment
    const payPointId = this.session.GetSelectedTerminal()?.PayPoint;
    const payPoint = this.session.defaultData.defData.PayPoints.find(i => i.Id === payPointId);
    if (payPoint){
      const tenderedValue = this.tenderAmountCtl.value;
      const reference = this.cardPaymentService.generateReference();
      
      // setup up subscription
      this.cardPaymentService.onResult.pipe(take(1)).subscribe((payload) => {
        // TODO:  Check result is valid/successful

        // set flag - this is used within checksale to determine whether we should auto make sale if other criteria are met
        this.usedPayPoint = true;

        // add tender to basket
        this.tender$.next('creditcard');
      });

      // make card payment
      this.cardPaymentService.makeCardPayment(payPoint, this.constants.uuidv4(), reference, tenderedValue);
    }
  }

  doTender(item) {
    let tenderType = 0;

    const tenderedValue = this.tenderAmountCtl.value;
    this.tenderAmountCtl.value = 0;

    if (tenderedValue <= 0.0) {
      return;
    }

    let desc = '';
    if (item === 'cash') {
      tenderType = enumSaleItemType.CashTendered;
      desc = 'Cash Tendered';
    }
    if (item === 'creditcard') {
      tenderType = enumSaleItemType.CardTendered;
      desc = 'Card Tendered';
      if (tenderedValue > this.outstandingBalance) {
        return;
      }
    }
    if (item === 'voucher') {      
      this.dlgTenderVoucher.show(this.outstandingBalance, item, this.saleItems);      
      return;
    }

    let si = this.saleItems.find(i => i.Tendered === true && i.SaleItemType === tenderType);
    if (si === undefined) {
      si = new SaleItem();

      si.SaleItemId = tenderType;
      si.ProductId = -1;
      si.Description = desc;
      si.Price = 0.0;
      si.Qty = 1;
      si.Tendered = true;
      si.SaleItemType = tenderType;
      this.saleItems.unshift(si);
    }
    si.Price = si.Price + tenderedValue;

    this.UpdateSale();
  }

  TenderVoucherDlgClosed(e:{action:string, saleItem: SaleItem, voucher:VoucherDetails}) {
    if (e.action!="USEVOUCHER")
    {
      this.UpdateSale()
      return;
    }

    // Add new item to saleItems    
    var si = new SaleItem();

    const q = this.saleItems.filter(i => i.SaleItemType < enumSaleItemType.CashTendered).length || 0;
    si.SaleItemId = q + 1;      
    si.ProductId = -1;
    si.Description = "Voucher : "+e.voucher.VoucherCode;
    si.Price = 0.0;
    si.Qty = 1;
    si.Tendered = true;
    si.IsVoucher=true;
    si.VoucherCode=e.voucher.VoucherCode;
    si.SaleItemType = enumSaleItemType.VoucherTendered;
    this.saleItems.unshift(si);  

    var tenderedValue=0;    
    if ( this.outstandingBalance>e.voucher.RemainingBalance)
    {
      tenderedValue = e.voucher.RemainingBalance;
    }
    else
    {
      tenderedValue = this.outstandingBalance;
    }
    si.Price = si.Price + tenderedValue;

    this.UpdateSale();
  }

  btnOutstandingBalance(e) {
    const siOB = this.saleItems.find(i => i.SaleItemType === enumSaleItemType.OutstandingBalance);
    this.tenderAmountValue = siOB.Price;
    this.tenderAmountCtl.value = siOB.Price;
  }

  Reset() {
    this.saleItems = new Array<SaleItem>();
    this.saleItems.push(SaleItem.Create(enumSaleItemType.SaleValue, 'Sale Value'));
    this.saleItems.push(SaleItem.Create(enumSaleItemType.TotalToPay, 'Total To Pay'));
    this.saleItems.push(SaleItem.Create(enumSaleItemType.TotalTendered, 'Total Tendered'));
    this.saleItems.push(SaleItem.Create(enumSaleItemType.OutstandingBalance, 'Outstanding Balance'));
    this.saleItems.push(SaleItem.Create(enumSaleItemType.Change, 'Change'));

    this.selectedResource = null;
    this.selectedSession = null;
    this.disableMakeSale = true;
    this.disableBookApt = true;
    this.AllowBooking = false;
    this.aptState = AppointmentState.New;
    this.UpdateSale();
  }

  onCloseSaleItemDlg(e) {
    console.log(e);
    if (e.Action === 'CANCEL') {
      return;
    }

    if (e.Action === 'UPDATE') {
      const si: SaleItem = this.saleItems.find(i => i.SaleItemId === e.saleItem.SaleItemId);
      if (si) {
        if ((si.Qty!=e.saleItem.Qty) && (si.SaleItemType == enumSaleItemType.Course)) this.ResetCreditsCalculations();
        si.Qty = e.saleItem.Qty;
        si.StaffUpdatedPrice = e.saleItem.StaffUpdatedPrice;
        si.Price = e.saleItem.Price;
        si.DiscountCode= e.saleItem.DiscountCode;        
        si.Discount = e.saleItem.Discount;
      }

      this.RemoveTenderItems();

      // Update Sale
      this.UpdateSale();
    }
    if (e.Action === 'DELETE') {
      this.deleteItem(null, e.saleItem.SaleItemId);
    }
  }

  RemoveTenderItems() {
    // Remove Cash/Card/Voucher tendered items
    this.saleItems = this.saleItems.filter(i => i.SaleItemType !== enumSaleItemType.CashTendered 
      && i.SaleItemType !== enumSaleItemType.CardTendered
      && i.SaleItemType !== enumSaleItemType.VoucherTendered
      );
    this.UpdateSale();
  }

  ResetCreditsCalculations(){
    if (this.saleItems){
      this.saleItems.forEach(i => {
        i.CreditsCalculated = false;
      });
    }
  }
}


